export default __webpack_public_path__ + "static/media/coupon-ticket.031bd2a7.svg";